import { RoundTo3 } from "./RoundTo3";

export function XML_AddArc(x0, y0, x1, y1, x2, y2, xmlCanvas) {
  var s = xmlCanvas.GetStream();

  x0 = RoundTo3(x0);
  x1 = RoundTo3(x1);
  x2 = RoundTo3(x2);
  y0 = RoundTo3(y0);
  y1 = RoundTo3(y1);
  y2 = RoundTo3(y2);

  xmlCanvas.OutputElementSex("arc", x0, y0, x1, y1, x2, y2, s);
}
